export const extractLocation = (answerStr: string): string | null => {
	if (!answerStr || typeof answerStr !== 'string') {
		return null;
	}

	// Remove extra whitespace and normalize
	const normalizedText = answerStr.trim().replace(/\s+/g, ' ');

	// Too short to be an address
	if (normalizedText.length < 5) {
		return null;
	}

	// Comprehensive address pattern
	// This pattern supports:
	// - Street numbers and names
	// - Unit numbers (e.g., #123, Apt 123, Suite 123)
	// - City/region/state names
	// - Optional state abbreviations (e.g., CA, TX, NSW)
	// - Optional postal/ZIP codes
	// - Optional country names
	const addressPattern =
		/\b\d{1,5}\s+[\w\s\.,\-#]+(?:#\d+|,\s*(?:Apt|Suite|Unit|Room|Fl|Floor)?\s*\d+)?\s*,\s*[\w\s]+,\s*[A-Z]{2,3}(?:\s*\d{4,5}(?:-\d{4})?)?(?:,\s*[A-Za-z\s]+)?\b/i;

	// Match the address in the text
	const match = normalizedText.match(addressPattern);
	if (match) {
		return match[0]; // Return the matched address
	}

	// If no match is found, return null
	return null;
};
